import { render, staticRenderFns } from "./ItemPagination.vue?vue&type=template&id=2f3b2082&scoped=true"
import script from "./ItemPagination.vue?vue&type=script&lang=js"
export * from "./ItemPagination.vue?vue&type=script&lang=js"
import style0 from "./ItemPagination.vue?vue&type=style&index=0&id=2f3b2082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b2082",
  null
  
)

export default component.exports